Privacy policy and terms of use for users (PDF)